import * as React from 'react';
import { BrowserAPIContext } from '../BrowserAPI.js';

// Hook to use the fetch API
var useFetch = function useFetch() {
  var _React$useContext = React.useContext(BrowserAPIContext),
    fetch = _React$useContext.fetch;
  return fetch;
};

export { useFetch };
//# sourceMappingURL=useFetch.js.map
